import Vue from 'vue'
import ModalLayout from "./components/Modals/Layouts/DialogLayout";
import ModalAlert from "./components/Modals/AlertModal";

const ModalBus = new Vue();

ModalBus.open = function ({component, props = {}, layout = ModalLayout}) {
    ModalBus.$emit('open', {component, props, layout});
};

ModalBus.close = function () {
    ModalBus.$emit('close');
};

ModalBus.alert = function (title, content, {
    icon = 'fas fa-check',
    buttons = [],
    closeButton = true
}) {
    ModalBus.open({
        component: ModalAlert,
        props: {
            title,
            content,
            icon,
            buttons,
            closeButton
        }
    });
};

ModalBus.alertSuccess = function (title, content, options = {}) {
    return ModalBus.alert(title, content, {icon: 'fas fa-check', ...options});
};

ModalBus.alertError = function (title, content, options = {}) {
    return ModalBus.alert(title, content, {icon: 'fas fa-exclamation', ...options});
};

ModalBus.processingError = function () {
    ModalBus.alertError('Une erreur est survenue', 'Une erreur est survenue lors du traitement de votre demande, veuillez réessayer.');
};

export default ModalBus;
